export const formatFees = (
  fees: string | number | undefined | null,
  currencySymbol?: string,
  conversionRate?: number
): string => {
  if (fees === null || fees === undefined || fees === "") {
    return "Not Provided";
  }

  const feesNumber = typeof fees === "string" ? parseFloat(fees) : fees;

  if (isNaN(feesNumber)) {
    return "Invalid Amount";
  }

  if (!currencySymbol) {
    currencySymbol = `AU$`;
  }

  if (!conversionRate) {
    conversionRate = 1;
  }

  return `${currencySymbol}${Math.round(
    feesNumber * conversionRate
  ).toLocaleString()}`;
};

export const formatFieldOfStudy = (
  fields: string[] | null | undefined
): string => {
  if (!fields || fields.length === 0) return "";
  return fields.join(" / ");
};
